import { useOverlays } from "contexts/OverlayContext";
import { FinancialDocumentDetailsModal } from "./FinancialDocumentDetailsModal";

/**
 * Global overlay host for `financialDocumentDetailsModal` \u2014 opens the same
 * document details modal used on the Documents page, but reachable from
 * anywhere (e.g. clicking a document reference chip in task chat).
 */
export const FinancialDocumentDetailsModalOverlay = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("financialDocumentDetailsModal");

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <FinancialDocumentDetailsModal
            financialDocumentId={overlayInfo.data}
            open={!overlayIsClosing}
            onClose={closeOverlay}
        />
    );
};
